/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {WhoAmIRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'
import {WhoAmIResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'


export const whoAmI = (request: WhoAmIRequest, options?: CashRequestOptions) => post<WhoAmIRequest, WhoAmIResponse>("/2.0/cash/who-am-i", request, {...options, rejectOnError: true })